import { Dispatch } from 'redux';
import { Moment } from 'moment';

export const DATE_SET_FROM = 'FLIGHT_DATE_SET_FROM';
export const DATE_SET_TO = 'FLIGHT_DATE_SET_TO';

export const setFromAction = (from: Moment) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DATE_SET_FROM,
        from: from
    });
};

export const setToAction = (to?: Moment) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DATE_SET_TO,
        to
    });
};



// WEBPACK FOOTER //
// ./src/actions/Flight/dates.ts